// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np.qr_code[data-v-bb8d21a6] {\n  height: 1px;\n  overflow: hidden;\n}\nol.steps[data-v-bb8d21a6] {\n  padding-left: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
